import { filterProps } from 'framer-motion'
import React from 'react'
import {BsTwitter, BsInstagram} from 'react-icons/bs'


const SocialMedia = () => {
  return (
    <div className='app__social'>
        <a href='https://twitter.com/thelotachi'>
        <div>
            <BsTwitter />
        </div>
        </a>
  
        <a href='https://instagram.com/thelotachi'>
        <div>
            <BsInstagram />
        </div> </a>
    </div>
  )
}

export default SocialMedia